/**
 * Групи сфер для екранів вибору (owner 2026-08-29: «хочу при виборі сфер їх
 * красиво поділити на категорії, щоб було зручно візуально»).
 *
 * 26 сфер суцільним списком не читаються — людина шукає своє очима по всьому
 * екрану. Групи дають ту саму структуру, що й у розмові: дизайн окремо,
 * розробка окремо, зйомка окремо.
 *
 * Порядок груп і порядок слагів усередині групи — те, що бачить користувач.
 * Сфера, якої тут немає (додали нову і забули вписати), не губиться: вона
 * потрапляє в «Інше» в кінці списку.
 */

export type CategoryGroup = {
  /** Заголовок над блоком. */
  title: string;
  /** Слаги у тому порядку, в якому їх показуємо. */
  slugs: string[];
};

export const CATEGORY_GROUPS: CategoryGroup[] = [
  {
    title: "Дизайн",
    slugs: [
      "graph_design",
      "ui_ux",
      "another_design",
      "branding",
      "illustration",
      "design_3d",
    ],
  },
  {
    title: "Розробка",
    slugs: [
      "frontend",
      "backend",
      "fullstack",
      "chat_bots_developing",
      "sites_on_constructors",
      "sites_code",
    ],
  },
  {
    // Motion — саме сюди, а не в дизайн (owner 2026-08-29).
    title: "Фото і відео",
    slugs: ["photo", "videography", "ugc", "video_editing", "motion_design"],
  },
  {
    title: "Маркетинг і реклама",
    slugs: [
      "marketing",
      "targeted_ad",
      "context_ads",
      "seo",
      "smm",
      "content_for_soc_networks",
      "pr_influencers",
    ],
  },
  {
    title: "Тексти і продажі",
    slugs: ["texts", "sales_crm"],
  },
];

const OTHER_TITLE = "Інше";

/**
 * Розкласти сфери по групах. Порожні групи не повертаємо — на стенді чи після
 * вимкнення сфери список може бути неповним.
 */
export function groupCategories<T extends { slug: string }>(
  items: T[],
): { title: string; items: T[] }[] {
  const bySlug = new Map(items.map((c) => [c.slug, c]));
  const used = new Set<string>();
  const groups: { title: string; items: T[] }[] = [];

  for (const group of CATEGORY_GROUPS) {
    const picked: T[] = [];
    for (const slug of group.slugs) {
      const item = bySlug.get(slug);
      if (item) {
        picked.push(item);
        used.add(slug);
      }
    }
    if (picked.length) groups.push({ title: group.title, items: picked });
  }

  const rest = items.filter((c) => !used.has(c.slug));
  if (rest.length) groups.push({ title: OTHER_TITLE, items: rest });

  return groups;
}
